import React from "react";
export const OurStory = () => {
  return (
    <>
      <div className="flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
        <div className="w-[30%] mobile:w-full">
          <h2 className="mb-2 text-2xl font-bold  mobile:hidden  mobile:text-lg">Our Story</h2>
        </div>
        <div className="w-[70%] mobile:w-full">
          <h2 className=" mb-2 text-2xl  font-bold  mobile:text-lg">
            <span className="hidden mobile:inline"> Our Story: </span>
            Championing Individual Liberty Before It Was In Vogue
          </h2>
          <p>
            The year was 1956. Barely ten years after India won independence from colonial powers the country had all
            but surrendered to the Nehruvian consensus.
          </p>
          <br />
          <p>
            One group of freedom fighters and patriots, including
            <b> C Rajagopalachari, better known as &quot;Rajaji&quot;</b> , became increasingly disillusioned by Pandit
            Nehru’s steering of India towards becoming a socialist state.
          </p>
          <br />

          <p>
            Rajaji, who Gandhiji referred to as the “keeper of my conscience” was the country’s first Indian head of
            state as the last Governor-General between 1948 and 1950, a freedom fighter, and a staunch patriot. He
            emerged as a beacon of hope for the Indian right-of-centre and his ideas represented the re-ignition of
            classic liberalism in new India.
          </p>
          <div className="my-3 flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
            <div className="  w-[100%] mobile:w-full">
              <img src="https://swarajya.gumlet.io/assets/coming.png" alt="My Image" />
            </div>
          </div>

          <p>
            It is in this setting, under Rajaji’s patronage, that Swarajya was launched in <b>1956 </b>by journalist
            Khasa Subba Rau, an inspiring figure in his own right. His ethical clarity, intellectual honesty, and the
            ability to speak truth to power, accentuated his reputation as a bold journalist.
          </p>
          <br />

          <p>
            Despite the odds stacked against it, and long before it became fashionable, Swarajya championed individual
            liberty, private enterprise, minimal state and cultural rootedness. The magazine represented the first
            fierce and coherent intellectual response to Nehruvian socialism.
          </p>
          <br />

          <p>
            Our customary salutation <b>“Dear Reader”</b> is an eponymous tribute to Rajaji’s popular column in Swarajya
            which became his prime instrument for a sustained critique of “permit-licence-quota raj&quot;, a phrase
            coined by Rajaji himself.
          </p>
          <br />

          <p>
            Explaining Swarajya`s mission in its early days, Rajaji wrote:&quot;There is before the country the great
            problem of how to secure welfare without surrendering the individual to be swallowed up by the state, how to
            get the best return for the taxes the people pay and how to preserve spiritual values while working for
            better material standards of life. This journal will serve all these purposes.&quot;
          </p>
          <br />
        </div>
      </div>
    </>
  );
};

export const SecondComing = () => {
  return (
    <>
      <div className="flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
        <div className="w-[30%] mobile:w-full">
          <h2 className="mb-2 text-2xl font-bold  mobile:hidden  mobile:text-lg">The Second Coming</h2>
        </div>
        <div className="w-[70%] mobile:w-full">
          <h2 className=" mb-2 text-2xl  font-bold  mobile:text-lg">
            <span className="hidden mobile:inline">The Second Coming: </span>
            Real Swarajya And Cultural Resurgence
          </h2>

          <div className="my-3 flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
            <div className="w-[100%] mobile:w-full" style={{ position: "relative", height: 0, paddingBottom: "50%" }}>
              <img
                src="https://swarajya.gumlet.io/assets/ram.jpg"
                alt="My Image"
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <p>
            Almost seven decades since Swarajya’s first reckoning, India has at long last begun to unshackle itself from
            the “permit-licence-quota raj&quot; and finally seems to be moving, unapologetically, towards freedom of
            enterprise.
          </p>
          <br />
          <p>
            But, in many ways, the battles that Rajaji and Rau fought continue to be extremely relevant. While the
            polity and economy are seemingly moving forward, the Indian mind continues to subscribe to ideas that are
            many times not grounded in real historical fact, and were in fact manufactured by invaders and colonialists
            to suit their own narrative.
          </p>
          <br />

          <p>
            For close to a millennia, the Indian psyche has been boxed in and effectively rewired. Even post
            independence, instead of liberation, Indians faced a continued colonisation of the mind through media,
            academia and polity, most all still controlled – directly or indirectly – by former invaders and colonial
            powers.
          </p>
          <br />
          <p>
            The voices that were conscious of the original Indian genius, and the ‘progrom’ of intellectual colonial
            boxing-in were suppressed or ignored.
          </p>
          <br />
          <p>
            Swarajya seeks to undo this subjugation of the Indian psyche. It seeks to rearticulate the ancient genius of
            the Indian mind, and speak for the modern Indian who is deeply rooted in our civilisational culture, while
            also relentlessly seeking to move it forward in the quest for the Indian Renaissance.
          </p>
          <br />
          <p>
            In our opinion, without an Indian cultural renaissance the full potential of India’s polity and economy will
            never be achieved. The free, probing, and inquisitive Indian mind is a far more superior force when it is in
            consonance with the original wisdom of this ancient land.
          </p>
          <br />
        </div>
      </div>
    </>
  );
};

export const Renaissance = () => {
  return (
    <>
      <div className="flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
        <div className="w-[30%] mobile:w-full">
          <h2 className=" text-2xl font-bold  mobile:text-lg ">The Churn Of Renaissance</h2>
        </div>
        <div className=" w-[70%] mobile:mt-0 mobile:w-full">
          <div className="my-3 flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
            <div className="w-[100%] mobile:w-full" style={{ position: "relative", height: 0, paddingBottom: "50%" }}>
              <img
                src="https://swarajya.gumlet.io/assets/moonlanding.png"
                alt="My Image"
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
          <p>
            <b>Swarajya’s</b> mission is to catalyse this new Indian Renaissance that impacts all aspects of modern
            Indian life– economy, civic life, culture, heritage, education, sustainable urban development, and more.
          </p>
          <br />
          <p>
            Swarajya draws from this ancient land’s civilisational ethos to
            <b>
              &nbsp; ‘shape the modern Indian’s worldview, speak for those invested in the cultural and economic
              prosperity of the nation, and influence decision making by communicating our views and ideas in a
              thoughtful and compelling way’
            </b>
          </p>
          <br />

          <p>
            Swarajya believes it is time to inverse relationships and engage with the world from India’s perspective. We
            root our outlook in India’s unique context, history, and lived experience as the oldest continuously
            surviving and thriving civilisational state.
          </p>
          <br />
        </div>
      </div>
    </>
  );
};

export const Editorial = () => {
  return (
    <>
      <div className="flex w-[100%] gap-3 mobile:w-full mobile:flex-col">
        <div className="w-[30%] mobile:w-full">
          <h2 className=" text-2xl font-bold mobile:text-lg ">Our Editorial Outlook</h2>
        </div>
        <div className=" mt-4 w-[70%] mobile:mt-0 mobile:w-full">
          <p>Swarajya believes there are three primary stakeholders of the Indian Renaissance:</p>
          <br />

          <p>
            <b>A Modern State: </b>We bat for a small, but strong state that is ever more capable of serving the best
            interests of India without swallowing the individual and her freedoms.
          </p>
          <br />
          <p>
            <b>An Enlightened Society:</b> We stand for a society that is prosperous, rooted in India’s civilisational
            values, and yet always looking to better its ancestors culturally, socially, and economically.
          </p>
          <br />
          <p>
            <b> A Free Individual:</b> We believe every individual should have opportunies to flourish in all spheres of
            life, basis their capabilities, without the shackles of the past.
          </p>
          <br />
          <p>
            Swarajya values content that is reasoned in nature, in consonance with civilisational values, and
            contemporary in format. We are bulding a self-sustaining business model based on reader revenue generated by
            our quality content.
          </p>
        </div>
      </div>
    </>
  );
};
